<template>
    <svg width="40" height="25" viewBox="0 0 40 25" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.685 0c10.661 0 19.117 11.175 19.467 11.652.289.386.289.916 0 1.302-.35.477-8.806 11.652-19.467 11.652C9.023 24.606.568 13.431.217 12.954a1.088 1.088 0 0 1 0-1.302C.567 11.175 9.023 0 19.685 0zm.284 4.471-.284.003a7.832 7.832 0 1 0 0 15.658 7.832 7.832 0 1 0 0-15.658zm-.284 3.221a4.615 4.615 0 1 1 0 9.231 4.615 4.615 0 0 1 0-9.23z" fill="#043D89" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconEye',
};
</script>
